import React, { useState, useEffect } from "react";
import { Card, Row, Col, Spinner, Table } from "@themesberg/react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { fetchApi } from "../../redux/api";
import { formatNumber } from "../../redux/utils";
import BackButton from "../../components/BackButton";
import ResponsiveContainer from "../../components/ResponsiveContainer";

function RetentionView() {
  const { contractor_id, contract_no, total_retention } = useParams();
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchApi(`retention-report?contractor_id=${contractor_id}&contract_no=${contract_no}`)
      .then((resp) => {
        if (resp.success && resp.results) {
          setRecords(resp.results);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [contractor_id, contract_no]);

  const first = records[0] || {};

  const allTaxFields = [
    { label: "VAT (7.5%)", key: "vat" },
    { label: "WHT (2%)", key: "wht_2" },
    { label: "WHT (5%)", key: "wht_5" },
    { label: "SD (1%)", key: "sd" },
    { label: "EL (2%)", key: "el" },
    { label: "CSR", key: "csr" },
    { label: "Vetting fee", key: "vetting_fee" },
    { label: "Retention", key: "retention" },
    { label: "Contract Award fee", key: "contract_award_fee" },
    { label: "Tender", key: "tender" },
    { label: "WR", key: "wr" },
    { label: "Others", key: "others" },
  ];

  const alwaysFields = [
    { label: "Net Amount", key: "net_amount" },
  ];

  const visibleTaxFields = allTaxFields.filter((tf) =>
    records.some((r) => parseFloat(r[tf.key] || 0) !== 0)
  );

  const amountPaidFields = [...visibleTaxFields, ...alwaysFields];

  return (
    <ResponsiveContainer>
      <BackButton />
      <Card>
        <Card.Body>
          <h5 className="mb-3">Retention Details</h5>

          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : records.length === 0 ? (
            <p className="text-muted">No retention records found.</p>
          ) : (
            <>
              <p><strong>Contract No.:</strong> {contract_no}</p>
              <p><strong>Contractor Name:</strong> {first.contractor_name || "N/A"}</p>
              <p><strong>Total Contract Amount:</strong> ₦{formatNumber(records.reduce((s, r) => s + parseFloat(r.total_contract_amount || 0), 0))}</p>
              <p><strong>Total Retention:</strong> ₦{formatNumber(total_retention)}</p>

              <hr />
              <h5 className="mb-3">Payment Details</h5>

              <div style={{ overflowX: "auto" }}>
              <Table hover bordered responsive size="sm">
                <thead className="table-header">
                  <tr>
                    <th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>Date</th>
                    <th rowSpan={2} style={{ textAlign: "center", verticalAlign: "middle" }}>PV Code</th>
                    <th colSpan={amountPaidFields.length} style={{ textAlign: "center" }}>Amount Paid</th>
                    <th rowSpan={2} style={{ textAlign: "right", verticalAlign: "middle" }}>Gross</th>
                  </tr>
                  <tr>
                    {amountPaidFields.map((f) => (
                      <th key={f.key} style={{ textAlign: "right" }}>{f.label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {records.map((r, i) => (
                    <tr key={i}>
                      <td style={{ textAlign: "center" }}>{r.pv_date}</td>
                      <td style={{ textAlign: "center" }}>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/pv-pdf/check?approval_no=${r.approval_no}&approval_type=undefined&pv_code=${r.pv_code}`);
                          }}
                        >
                          {r.pv_code}
                        </a>
                      </td>
                      {amountPaidFields.map((f) => {
                        const val = f.key === "net_amount"
                          ? r.total_contract_amount - r.total_deduction - total_retention
                          : parseFloat(r[f.key] || 0);
                        return (
                          <td key={f.key} style={{ textAlign: "right" }}>₦{formatNumber(val)}</td>
                        );
                      })}
                      <td style={{ textAlign: "right" }}>₦{formatNumber(r.total_contract_amount)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="fw-bold">
                    <td colSpan={2}></td>
                    {amountPaidFields.map((f) => {
                      const val = f.key === "net_amount"
                        ? records.reduce((s, r) => s + (r.total_contract_amount - r.total_deduction - total_retention), 0)
                        : records.reduce((s, r) => s + parseFloat(r[f.key] || 0), 0);
                      return (
                        <td key={f.key} style={{ textAlign: "right" }}>₦{formatNumber(val)}</td>
                      );
                    })}
                    <td style={{ textAlign: "right" }}>
                      ₦{formatNumber(records.reduce((s, r) => s + parseFloat(r.total_contract_amount || 0), 0))}
                    </td>
                  </tr>
                </tfoot>
              </Table>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </ResponsiveContainer>
  );
}

export default RetentionView;
